import { useFundList } from "gen/endpoints/fund-entities/fund-entities";
import React from "react";
import {
  FormSelect,
  FormSelectProps,
  Select,
  SelectProps,
} from "shared/components/input/select/Select";
import { SelectOption } from "shared/components/input/select/SelectOption";

export interface FormEntitySelectProps extends FormSelectProps {
  fundFamilyId: string;
}

export interface EntitySelectProps extends SelectProps {
  fundFamilyId: string;
}

export const FormFundEntitySelect: React.FC<FormEntitySelectProps> = ({
  fundFamilyId,
  ...props
}) => {
  const { data } = useFundList({ fund_family_ids: [fundFamilyId] });
  return (
    <FormSelect {...props}>
      {data?.map((entity) => (
        <SelectOption key={entity.id} value={entity.id}>
          {entity.legal_name}
        </SelectOption>
      ))}
    </FormSelect>
  );
};

export const FundEntitySelect: React.FC<EntitySelectProps> = ({
  fundFamilyId,
  ...props
}) => {
  const { data } = useFundList({ fund_family_ids: [fundFamilyId] });
  return (
    <Select {...props}>
      {data?.map((entity) => (
        <SelectOption key={entity.id} value={entity.id}>
          {entity.legal_name}
        </SelectOption>
      ))}
    </Select>
  );
};
